import React, {useState} from 'react';
import {styles} from './styles.web';
import {ButtonProps} from './Button.types.web';
import {
  getButtonGeneralStyles,
  getButtonContentStyles,
} from './Button.config.web';
import {useTheme} from '../../../../utils/theming/themeProvider';
import LoaderPrototipeIcon from '../../Icons/icons/loaderPrototipe';

const Button = (props: React.PropsWithChildren<ButtonProps>) => {
  // Props
  const {
    id,
    className,
    loading,
    color = 'grey',
    state = 'enable',
    style = 'fill',
    textSize = 'medium',
    LeadingIcon,
    showText = true,
    text = 'Hello button',
    containerStyle,
    onClick,
  } = props;

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const currentState =
    state === 'enable'
      ? isFocused
        ? 'focus'
        : isHovered
        ? 'hover'
        : 'enable'
      : state;

  // Button Styles
  const {colors, fontStyles} = useTheme();
  const buttonStyles = getButtonGeneralStyles(
    colors,
    color,
    style,
    currentState,
    textSize,
    !!LeadingIcon,
  );

  const containerStyles = styles();
  const buttonFontStyle = getButtonContentStyles(
    fontStyles,
    colors,
    color,
    style,
    currentState,
    textSize,
  );

  const iconColor = buttonFontStyle?.iconColor;

  return (
    <button
      id={id}
      className={className}
      style={{
        ...containerStyles?.buttonContainer,
        ...buttonStyles,
        ...buttonFontStyle?.styles,
        ...containerStyle,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onClick={currentState !== 'disable' ? onClick : undefined}>
      {!loading ? (
        <>
          {LeadingIcon && (
            <div style={{...containerStyles?.iconContainer}}>
              <LeadingIcon size={'24'} color={iconColor} style={'outline'} />
            </div>
          )}
          {showText && text && text}
        </>
      ) : (
        <LoaderPrototipeIcon size={'24'} color={iconColor} />
      )}
    </button>
  );
};

export default Button;
